import React from 'react';
import styled from 'styled-components';
import {
    Accordion as MuiAccordion,
    AccordionDetails as MuiAccordionDetails,
    AccordionProps as MuiAccordionProps,
    AccordionSummary as MuiAccordionSummary,
    fade,
    lighten,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { colorMap } from './constants';

type AccordionProps = Omit<MuiAccordionProps, 'square'>;

export const Accordion = styled((props: AccordionProps) => <MuiAccordion square {...props} />)`
    ${({ theme }) => `
        && {
            box-shadow: none;
            background-color: ${theme.palette.background.default};
            border-radius: ${theme.shape.borderRadius}px;
            :before {
                content: none;
            }
        }
    `}
`;

export const AccordionSummary = styled(MuiAccordionSummary)`
    &&.MuiAccordionSummary-root {
        cursor: default;
        user-select: auto;
        :hover {
            cursor: default;
        }
        &.Mui-expanded {
            min-height: 60px;
        }
    }
    .MuiAccordionSummary-content,
    .MuiAccordionSummary-content.Mui-expanded {
        margin: 10px 0;
    }
`;

export const AccordionDetails = styled(MuiAccordionDetails)`
    &&{
        padding-top: 0;
        padding-bottom: 10px;
    }
`;

export const CircleIconContainer = styled.div<{ color: keyof typeof colorMap }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    ${({ color }) => `
        background-color: ${fade(colorMap[color], 0.16)};
        color: ${colorMap[color]};
    `}
    border-radius: 50%;
`;

export const LinkContainer = styled(Link)`
    background: #E4E3FD;
    ${({ theme }) => `
        width: ${theme.spacing(5)}px;
        height: ${theme.spacing(5)}px;
        border-radius: ${theme.shape.borderRadius}px;
        color: ${theme.palette.primary.main};
    `}
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    :before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        ${({ theme }) => `
            width: ${theme.spacing(3)}px;
            height: ${theme.spacing(3)}px;
            background-color: ${lighten(theme.palette.background.default, 0.04)};
        `}
    }
    svg {
        z-index: 2;
    }
`;